/**
 * Help Center: how-to articles for every module, written from the real
 * screens (docs/help/*.md, compiled into @velora/contracts/help). In-app at
 * /help with categories, search and role filters; read-only and public at
 * /help/public (no sign-in, no patient data) so links can go in emails. The
 * top-bar "?" opens the current page's article; the global search (Ctrl+K)
 * finds articles and single steps; Ask Velora answers how-to questions from
 * the same articles.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';
import { registerSearchProvider } from '../../app/commands/registry.js';
import { helpSearchProvider } from './search-provider.js';

registerSearchProvider(helpSearchProvider);

export default defineWebModule({
  manifest: defineManifest({
    id: 'help',
    title: 'Help Center',
    version: '0.1.0',
    owner: 'WP0-HELP',
    entitlementKey: null,
    permissions: [],
    routes: [
      { id: 'center', path: '/help', title: 'Help Center', officeScope: 'practice' },
      { id: 'article', path: '/help/$articleId', title: 'Help article', officeScope: 'practice' },
      // Public, read-only (barePaths.ts): no sign-in, no shell, no patient data.
      { id: 'public', path: '/help/public', title: 'Velora Help', officeScope: 'practice' },
      {
        id: 'public-article',
        path: '/help/public/$articleId',
        title: 'Velora Help',
        officeScope: 'practice',
      },
    ],
    nav: [
      { label: 'Help Center', group: 'meta', routeId: 'center', icon: 'circle-help', order: 80 },
    ],
    commands: [
      {
        id: 'help.open',
        title: 'Go to Help Center',
        keywords: [
          'help',
          'how to',
          'how do i',
          'guide',
          'training',
          'manual',
          'article',
          'support',
        ],
        routeId: 'center',
      },
    ],
    sseEntityKeys: [],
    phiReadPoints: [],
  }),
  pages: {
    center: () => import('./HelpCenterPage.js'),
    article: () => import('./HelpArticlePage.js'),
    public: () => import('./PublicHelpPage.js'),
    'public-article': () => import('./PublicHelpPage.js'),
  },
});
